<template>
    <div class="relative inset-y-0 right-0 flex items-center">
        <simple-dropdown ref="ddmActions" position="right">
            <template #trigger>
                <simple-button
                    small
                >
                    {{ label }}
                </simple-button>
            </template>
            <template #content>
                <nav
                    aria-orientation="vertical"
                    class="bg-white relative rounded shadow"
                    role="menu"
                >
                    <dropdown-item
                        :input-label="$t('general.required')"
                        @click="$emit('subscribe', 'required')"
                    />
                    <dropdown-item
                        :input-label="$t('general.optional')"
                        @click="$emit('subscribe', 'optional')"
                    />
                </nav>
            </template>
        </simple-dropdown>
    </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
import SimpleDropdown from "./SimpleDropdown.vue";
import User from "../../models/User";
import SimpleButton from "./SimpleButton.vue";
import DropdownItem from "./DropdownItem.vue";

export default {
    name: 'dropdown-button',
    components: {
        DropdownItem,
        SimpleButton,
        SimpleDropdown,
        'svg-icon': SvgIcon,
    },
    props: {
        label: {type: String, default: ''},
        loading: {
            type: Boolean,
            default: false,
        },
        user: User
    },
    data: function () {
        return {
            buttonClasses: {
                none: '',
                primary: 'rounded-32 text-white',
                secondary: 'rounded-sm text-white',
                success: 'rounded-sm text-white',
                danger: 'rounded-sm text-white',
                warning: 'rounded-sm text-white px-24 py-12',
                info: 'rounded-sm text-white px-24 py-12',
                link: 'text-primary-60',
                outline: 'rounded-sm bg-transparent border',
                new: 'rounded-sm text-white px-24 py-12',
                newOutline: 'border rounded-sm px-24 py-12',
            },
            enabledClasses: {
                primary: 'bg-secondary-80 hover:bg-secondary',
                secondary: 'bg-primary hover:bg-primary-80',
                success: 'bg-secondary-80 hover:bg-secondary',
                danger: 'bg-semantic-error hover:bg-semantic-error',
                warning: 'bg-semantic-warning hover:bg-semantic-warning',
                info: 'bg-primary hover:bg-primary-60',
                link: 'hover:text-primary-80',
                outline: 'border-primary-20 text-primary-80 hover:border-primary-80',
                new: 'bg-secondary-80 hover:bg-secondary',
                newOutline: 'border-primary-20 text-primary hover:bg-primary-5',
            },
            disabledClasses: {
                primary: 'bg-secondary-20',
                secondary: 'bg-primary-5 text-primary-40',
                success: 'bg-secondary-20',
                danger: 'bg-semantic-error-light',
                warning: 'bg-semantic-warning-light',
                info: 'bg-primary-20',
                link: '',
                outline: 'border-primary-20 text-primary-20',
                new: 'bg-secondary-20',
                newOutline: 'border-primary-20 text-primary-40',
            },
        };
    },
    computed: {
        buttonClass() {
            return this.buttonClasses[this.display];
        },
        enabledClass() {
            return this.enabledClasses[this.display];
        },
        disabledClass() {
            if (this.overrideDisabledClass) {
                return this.overrideDisabledClass;
            }

            return this.disabledClasses[this.display];
        },
        isDisabled() {
            return this.disabled || this.loading;
        },
        setButtonClasses() {
            let classes = [this.buttonClass];
            if (this.display === 'none') {
                return [];
            }

            if (this.isDisabled) {
                classes.push('cursor-not-allowed', this.disabledClass);
            } else {
                classes.push('cursor-pointer', this.enabledClass);
            }

            if (this.size === 'large') {
                if (!['new', 'newOutline', 'info'].includes(this.display) && !this.flexHeight) {
                    classes.push('h-40');
                }
                if (!['new', 'newOutline', 'info'].includes(this.display)) {
                    classes.push('px-20');
                }
            } else {
                classes.push('h-32', 'px-16');
            }

            if (this.display !== 'new' && this.display !== 'newOutline') {
                classes.push('tracking-wider', 'flex-none', 'text-body-sm');
            }

            return classes;
        }
    },
    methods: {
        handleClick() {
            this.$emit('click');
        },
    },
};
</script>
